// extracted by mini-css-extract-plugin
module.exports = {"tourMessage":"SendMessage_tourMessage__1f2jl","tourDuration":"SendMessage_tourDuration__QuYVQ","tourUrgent":"SendMessage_tourUrgent__2yFo2"};